import * as React from 'react';

/**
 * Application content wrapper for within a CASSI page
 */
const AppContent = ({
    children,
    className,
    ...props
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => {
    const componentClassName = `app-content ${className ?? ''}`.trim();

    return (
        <div
            data-testid="app-content"
            {...props}
            className={componentClassName}
        >
            {children}
        </div>
    );
};

export default AppContent;
